import { Helmet } from "react-helmet-async";

const SITE_URL = "https://tertuliaindubio.es";
const DEFAULT_IMAGE = `${SITE_URL}/assets/og-cover.jpg`;
const DEFAULT_TITLE = "Tertulia In Dubio · Tertulia Social de Sevilla";
const DEFAULT_DESC = "Archivo vivo de pensamiento desde 2014. Un foro sevillano donde profesionales de diversos ámbitos debaten los problemas sociales de nuestro tiempo. «In dubio, libertas.»";

/**
 * <Seo> — dynamic <head> tags per page.
 *
 * Props:
 *  - title: string (page-specific, will be suffixed with " · Tertulia In Dubio")
 *  - description: string
 *  - path: string (e.g. "/invitados") — for canonical + og:url
 *  - image: string (absolute URL or /api/... path)
 *  - type: "website" | "article" | "profile" (defaults to website)
 *  - schema: object | array — additional JSON-LD to inject
 *  - noindex: boolean
 */
export default function Seo({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image,
  type = "website",
  schema,
  noindex = false,
}) {
  const fullTitle = title ? `${title} · Tertulia In Dubio` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;
  const ogImage = resolveOg(image) || DEFAULT_IMAGE;
  const schemaArray = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Tertulia In Dubio" />
      <meta property="og:locale" content="es_ES" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemaArray.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}

function resolveOg(img) {
  if (!img) return null;
  if (img.startsWith("http")) return img;
  if (img.startsWith("/")) return `${SITE_URL}${img}`;
  return img;
}

export { SITE_URL };
